import { PulseScraperAPI } from "components/Apis/Pulse";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedWeek, setSelectedYear } from "redux/pulse/navigationSlice";
import { fetchScraperOperations } from "redux/scraperOperations/operationsSlice";

export const PulseSettings = () => {

    const dispatch = useDispatch();

    const { filters } = useSelector((state) => state.scraperOperations);
    const { selectedWeek } = useSelector((state) => state.pulseNavigation);

    return (
        <>
            <div className="pulse-section pt-0 mt-0">
                <div className="pulse-header pt-0 mt-0">
                    <h1>Scraper</h1>
                    <button
                        className="button"
                        onClick={() => {
                            PulseScraperAPI.runScraper({ year: new Date().getFullYear(), week: selectedWeek })
                                .catch((error) => {
                                    error.response?.data?.msg
                                        ? toast.error(error.response.data.msg)
                                        : error.response?.data?.detail
                                            ? toast.error(error.response.data.detail)
                                            : toast.error(error.message);
                                    console.error("Error running scraper:", error);
                                })
                                .then(() => {
                                    dispatch(fetchScraperOperations(filters));
                                })
                        }}
                    >
                        <span className="mr-2">Run</span>
                        <i className="nc-icon nc-button-play" style={{ fontWeight: 'bold' }}></i>
                    </button>
                </div>
                <div className="pulse-body">
                    <p className="text-muted">Configure scraper settings below:</p>
                    <div className="d-flex flex-row">
                        <div className="flex-column">
                            <label>
                                Select Week
                            </label>
                            <select
                                className="input thin"
                                defaultValue={selectedWeek}
                                onChange={(e) => dispatch(setSelectedWeek(e.target.value))}
                            >
                                {[...Array(52).keys()].map((week) => (
                                    <option key={week} value={week + 1}>
                                        Week {week + 1}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-column ml-3">
                            <label>
                                Select Year
                            </label>
                            <select
                                className="input thin"
                                onChange={(e) => dispatch(setSelectedYear(e.target.value))}
                            >
                                {[...Array(5).keys()].map((year) => (
                                    <option key={year} value={new Date().getFullYear() - year}>
                                        {new Date().getFullYear() - year}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        </>
    );
};